import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { RulesDynamicFormService } from '@app/sharedModule/components/rules-dynamic-form/rules-dynamic-form.service';
import { getExtensionRules } from '@app/pages/checkout-app/checkout-layout/main/components/extensions/shared/all-extension-rules';
import { PRODUCTS_IN_CART_RULE_ENTITIES } from '../../widget-editors/upsell-items/product-selection/product-selection.model';
import { SmartCartBlockType } from '../../smart-cart-block.model';

export const DISPLAY_CONDITION_RULES = getExtensionRules({ onlyRules: PRODUCTS_IN_CART_RULE_ENTITIES });
export const DISPLAY_CONDITION_ENTITIES = DISPLAY_CONDITION_RULES.map((rule) => rule.entity);

export interface DisplayConditionsValue {
  rules?: unknown[];
}

export const SUPPORTS_DISPLAY_CONDITIONS: ReadonlySet<SmartCartBlockType> = new Set([
  SmartCartBlockType.TOP_BAR,
  SmartCartBlockType.ANNOUNCEMENT_BAR,
  SmartCartBlockType.GOALS_PROGRESS_BAR,
  SmartCartBlockType.DISCOUNT_CODES,
  SmartCartBlockType.DIGITAL_UPSELL,
  SmartCartBlockType.UPSELL_ITEMS,
  SmartCartBlockType.ORDER_PROTECTION,
]);

export function createDisplayConditionsFormGroup(
  initial: DisplayConditionsValue | null | undefined,
  rulesDynamicFormService?: RulesDynamicFormService,
): UntypedFormGroup {
  const rules = (initial?.rules ?? []) as unknown[];
  return new UntypedFormGroup({
    rules: rulesDynamicFormService
      ? rulesDynamicFormService.initRulesFormArray(rules.flat(), DISPLAY_CONDITION_RULES)
      : new UntypedFormArray([]),
  });
}

export function attachDisplayConditions<T extends AbstractControl>(
  formGroup: T,
  initialSettings: Record<string, unknown> | null | undefined,
  rulesDynamicFormService?: RulesDynamicFormService,
): T {
  const initial = initialSettings?.['displayConditions'] as DisplayConditionsValue | undefined;
  (formGroup as unknown as UntypedFormGroup).addControl(
    'displayConditions',
    createDisplayConditionsFormGroup(initial, rulesDynamicFormService),
  );
  return formGroup;
}

export function readDisplayConditionsGroup(formGroup: AbstractControl): UntypedFormGroup | null {
  return (formGroup.get('displayConditions') as unknown as UntypedFormGroup | null) ?? null;
}
